import * as type from '../types/signIn';
import actionCreatorFactory from 'typescript-fsa';
var actionCreator = actionCreatorFactory();
export var requestSignIn = actionCreator(type.REQUEST_SIGN_IN);
export var successSignIn = actionCreator(type.SUCCESS_SIGN_IN);
export var failureSignIn = actionCreator(type.FAILURE_SIGN_IN);
export var clearState = actionCreator(type.CLEAR_STATE);